import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { DeliverySummary } from '../../../../app/services/api/generated';

interface DeliveredOnTimeProps {
  deliveries: DeliverySummary[];
}

const DeliveredOnTime = ({ deliveries }: DeliveredOnTimeProps) => {
  const theme = useTheme();

  const data: { name: string, value: number }[] = [
  ];

  // Example: count deliveries with status 'DeliveredOnTime'
  const deliveredOnTimeCount = deliveries.filter(d => d.status === 'DeliveredOnTime').length;
  const total = deliveries.length;
  const percent = total > 0 ? (deliveredOnTimeCount / total) * 100 : 0;

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <LineChart data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis dataKey="date"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <YAxis stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <Tooltip contentStyle={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
        <Line type="monotone"
          dataKey="percentage"
          stroke={theme.palette.success.main}
          strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default DeliveredOnTime;